import React from "react";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";
import { PositionTable } from "./PositionTable";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosPositionsAPI } from "../Api";

export const PositionListInactive = ({ search }) => {
  const { isPending, data, error, handlePrevious, handleNext } =
    useQueryWithPagination({
      queryKey: ["position-list-inactive", search],
      queryFn: AxiosPositionsAPI.getAll,
      search: search,
      active: false,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <PositionTable positions={data.results} active={false} />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
